import { ArrowDown, ArrowUp, Minus } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

type PeriodChangeIndicatorProps = {
  percentageChange: number
  direction: 'up' | 'down' | 'flat'
}

export const PeriodChangeIndicator = ({
  percentageChange,
  direction,
}: PeriodChangeIndicatorProps) => {
  if (direction === 'flat') {
    return (
      <Badge variant="secondary" className="gap-1 text-xs">
        <Minus className="size-3" />
        0%
      </Badge>
    )
  }

  const isUp = direction === 'up'

  return (
    <Badge
      variant="secondary"
      className={cn('gap-1 text-xs', {
        'text-destructive': isUp,
        'text-green-600 dark:text-green-400': !isUp,
      })}
    >
      {isUp ? <ArrowUp className="size-3" /> : <ArrowDown className="size-3" />}
      {percentageChange.toFixed(1)}%
    </Badge>
  )
}
